<template>
  <div class="hello" style="height: 100vh;" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <GlobalHeader style="position: absolute;" :activeIndex="activeIndex"/>
    <el-main>
      <div style="position: fixed;z-index: 111; background: #fff;width: calc(100% - 175px); min-width:1200px">
        <div class="edit">
          <div class="fl" style="justify-content: space-between; margin-left: 6px">
            <span style="width: 63px; background-color: #589ff9" @click="openChildDialog(1)">
              <img src="../../images/increase.png" style="width: 15px; height: 15px" alt=""/>
            </span>
          </div>
          <div @click="dialogVisible_one = true"
               style="    width: 80px;height: 25px;cursor: pointer;display: flex;border: 1px solid #589ff9;margin-left:10px;justify-content: center;border-radius: 5px;">
            <span style="font-size: 14px;">filter</span>
          </div>


          <el-input placeholder="员工姓名" v-model="name" clearable @change="getList" v-if="name"
                    :class="{ 'vip': name && name.length != '0' }">
          </el-input>

          <el-tooltip class="item" effect="dark" content="性别筛选" placement="bottom" v-if="sex">
            <el-cascader @change="sex_box" v-model="sex" popper-class='custom_box' placeholder="性别筛选"
                         :options="options1" filterable clearable :class="{ 'vip': sex && sex !== '性别筛选' }">
            </el-cascader>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" content="所属公司" placement="bottom" v-if="company_name">
            <el-cascader @change="company_name_box" v-model="company_name" placeholder="所属公司" :options="options2"
                         filterable clearable :class="{ 'vip': company_name && company_name !== '所属公司' }">
            </el-cascader>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" content="所属部门" placement="bottom" v-if="department_two">
            <el-select v-model="department_two" filterable placeholder="所属部门" @change="signChange"
                       style="margin-left: 6px;" clearable
                       :class="{ 'vip': department_two && department_two !== '所属部门' }">
              <el-option v-for="(item, index) in department_one" :key="index" :label="item.value_1" :value="item.id">
              </el-option>
            </el-select>
          </el-tooltip>


          <el-tooltip class="item" effect="dark" content="结算部门" placement="bottom" v-if="settlement_tow">
            <el-select v-model="settlement_tow" filterable placeholder="结算部门" @change="settlementChange"
                       style="margin-left: 6px;" clearable
                       :class="{ 'vip': settlement_tow && settlement_tow !== '结算部门' }">
              <el-option v-for="(item, index) in settlement_one" :key="index" :label="item.value_1" :value="item.id">
              </el-option>
            </el-select>
          </el-tooltip>


          <el-input placeholder="手机号" v-model="phone" @change="getList" v-if="phone"
                    :class="{ 'vip': phone && phone.length != '0' }">
          </el-input>
          <el-tooltip class="item" effect="dark" content="工作状态" placement="bottom">
            <el-cascader @change="work_status_box" v-model="work_status" :placeholder="placeholderText"
                         :options="options4" filterable clearable
                         :class="{ 'vip': work_status && work_status !== '工作状态' }" style="width: 137px;">
            </el-cascader>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" content="社保状态" placement="bottom" v-if="social_security">
            <el-cascader v-if="userRole != 5 " @change="social_security_box" v-model="social_security"
                         placeholder="社保状态" :options="options5" filterable clearable
                         :class="{ 'vip': social_security && social_security !== '社保状态' }">
            </el-cascader>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" content="入职时间" placement="bottom" v-if="value0 && value0.length">
            <el-date-picker v-model="value0" style="width: 137px;margin-left: 6px;" type="daterange"
                            :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator=""
                            start-placeholder="入职时间" align="right"
                            :class="{ 'your-css-class_box': !isValue3Empty_1 }"
                            value-format="timestamp" @change="getList">
            </el-date-picker>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="离职时间" placement="bottom" v-if="value1 && value1.length">
            <el-date-picker v-model="value1" style="width: 137px;margin-left: 6px;" type="daterange"
                            :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator=""
                            start-placeholder="离职时间" align="right"
                            :class="{ 'your-css-class_box': !isValue3Empty_2 }"
                            value-format="timestamp" @change="getList">
            </el-date-picker>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" content="合同到期" placement="bottom" v-if="value2 && value2.length">
            <el-date-picker v-if="userRole != 5 " v-model="value2" style="width: 137px;margin-left: 6px;"
                            type="daterange" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd"
                            range-separator=""
                            start-placeholder="合同到期" align="right"
                            :class="{ 'your-css-class_box': !isValue3Empty_3 }"
                            value-format="timestamp" @change="getList">
            </el-date-picker>
          </el-tooltip>
          <el-input v-if="userRole != 5  " placeholder="籍贯" v-model="native_place" clearable v-show="native_place"
                    :class="{ 'vip': native_place && native_place.length != '0' }" @change="getList">
          </el-input>
          <el-input v-if="userRole != 5 " placeholder="身份证号码" v-show="identitycard"
                    :class="{ 'vip': identitycard && identitycard.length != '0' }" v-model="identitycard" clearable
                    @change="getList">
          </el-input>
          <el-input v-if="userRole != 5 " placeholder="备注" :class="{ 'vip': remark && remark.length != '0' }"
                    v-model="remark" clearable @change="getList" v-show="remark">
          </el-input>
          <span style="width: 69px;border: 1px solid #589ff9;margin-left: 5px;" @click="cleanUpEvt" v-if="hasContent">ALL</span>

          <span style="margin-left: 5px;border: 1px solid #589ff9;" @click="excelEvt" v-if="userRole == 6 ">EXCEL</span>

          <div style="display: flex;width: 300px;">
          </div>
        </div>


        <div class="" style="width: 100%">
          <span class="span_box">{{ total }}</span>
          <div class="btn2">
            <div class="pagination_box">
              <el-input v-model="paginationInput" style="width: 50px" size="mini" placeholder="To"
                        @change="limitEvt"></el-input>
              <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1"
                             :page-size="paginationInput - 0" layout="prev, pager, next, jumper" :total="total"
                             :pager-count="5">
              </el-pagination>
            </div>
            <button @click="minxEvt" :class="{ active: activeTab === '1' }">基本信息</button>
            <button @click="min_boxEvt" v-if="userRole != 3 && userRole != 4 && userRole != 5 && userRole != 8"
                    :class="{ active: activeTab === '2' }">公司信息
            </button>
            <button @click="min_oneEvt" v-if="userRole != 3 && userRole != 4 && userRole != 5 && userRole != 8"
                    :class="{ active: activeTab === '3' }">薪酬记录
            </button>
          </div>

          <el-table :data="tableData" ref="sortTable" height="55%" :summary-method="getSummaries" show-summary border
                    @sort-change="formatterEvt('sortTable', $event)" v-sort-orders="['descending', 'ascending', '']"
                    @cell-mouse-enter="huaguo" @cell-click="idEvt">
            <el-table-column prop="name" label="姓名" sortable width="100" align="left" fixed :sort-orders="orders">
              <template slot-scope='props'>
                <span @click="openChildDialog(2)" style="cursor: pointer;">{{ props.row.name }}</span>
              </template>
            </el-table-column>
            <template v-if="showNameColumn">
              <el-table-column prop="department" label="部门" sortable width="100" :sort-orders="orders">
              </el-table-column>
              <el-table-column prop="sex" label="性别" sortable width="80" :sort-orders="orders">
                <template slot-scope="scope">
                  <span v-if="scope.row.sex === 1">男</span>
                  <span v-else-if="scope.row.sex === 2">女</span>
                </template>
              </el-table-column>
              <el-table-column prop="age" label="年龄" sortable width="82" :sort-orders="orders"
                               v-if="userRole != 3 && userRole != 4 && userRole != 5">
              </el-table-column>
              <el-table-column prop="birthday" sortable label="生日" width="100" :sort-orders="orders">
              </el-table-column>
              <el-table-column prop="year" label="出生" sortable width="100" :sort-orders="orders"
                               v-if="userRole != 3 && userRole != 4 && userRole != 5 && userRole != 8">
              </el-table-column>
              <el-table-column prop="phone" label="手机号" sortable width="145" :sort-orders="orders">
              </el-table-column>
              <el-table-column prop="entry_time" label="入职时间" width="120" sortable :sort-orders="orders">
              </el-table-column>
              <el-table-column prop="native_place" label="籍贯" width="170" :sort-orders="orders"
                               class-name="project_one"
                               v-if="userRole != 3 && userRole != 4 && userRole != 5">
                <template slot-scope="scope">
                  <span class="white_over">{{ scope.row.native_place }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="identity_address" label="身份证地址" sortable width="310" :sort-orders="orders"
                               class-name="project_one"
                               v-if="userRole != 3 && userRole != 4 && userRole != 5 && userRole != 8">
                <template slot-scope="props">
                  <span class="white_over">{{ props.row.identity_address }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="identitycard" label="身份证号码" sortable width="233" :sort-orders="orders"
                               class-name="project_one"
                               v-if="userRole != 3 && userRole != 4 && userRole != 5 && userRole != 8">
              </el-table-column>
              <el-table-column prop="work_status" label="工作状态" width="100" sortable>
                <template slot-scope="scope">
                  <span v-if="scope.row.work_status === 1">实习</span>
                  <span v-else-if="scope.row.work_status === 2">兼职</span>
                  <span v-else-if="scope.row.work_status === 3">在职</span>
                  <span v-else-if="scope.row.work_status === 4">离职</span>
                </template>
              </el-table-column>
              <el-table-column prop="emergency_contact" label="紧急联系人" sortable width="130" :sort-orders="orders"
                               class-name="project_two" v-if="userRole != 3 && userRole != 4 && userRole != 5">
              </el-table-column>
              <el-table-column prop="emergency_contact_phone" label="紧急联系号" sortable :sort-orders="orders"
                               class-name="project_two" v-if="userRole != 3 && userRole != 4 && userRole != 5">
              </el-table-column>
            </template>

            <template v-if="showNameColumn_box">
              <el-table-column prop="department" label="部门" sortable width="140" :sort-orders="orders">
              </el-table-column>
              <el-table-column prop="settlement" label="结算部门" sortable width="105" :sort-orders="orders">

              </el-table-column>
              <el-table-column prop="company_name" label="所属公司" sortable width="110" :sort-orders="orders">
              </el-table-column>
              <el-table-column prop="social_security" label="社保状态" sortable width="110" :sort-orders="orders">
                <template slot-scope="scope">
                  <span v-if="scope.row.social_security === 1">缴纳</span>
                  <span style="color: #e7e5e5;" v-else-if="scope.row.social_security === 2">未缴纳</span>
                </template>
              </el-table-column>
              <el-table-column prop="entry_time" label="入职时间" sortable width="110" :sort-orders="orders"
                               class-name="project_showNameColumn">
              </el-table-column>
              <el-table-column prop="contract_time" label="合同到期" sortable width="100" :sort-orders="orders"
                               class-name="project_showNameColumn">
              </el-table-column>
              <el-table-column prop="departure_time" label="离职时间" sortable width="100" :sort-orders="orders"
                               class-name="project_showNameColumn">
              </el-table-column>
              <el-table-column prop="remark" label="备注" sortable :sort-orders="orders">
              </el-table-column>
            </template>


            <template v-if="showNameColumn_box_one">

              <el-table-column prop="department" label="部门" width="200" sortable :sort-orders="orders">
              </el-table-column>
              <el-table-column prop="settlement" label="结算部门" width="100" sortable :sort-orders="orders">
              </el-table-column>
              <el-table-column prop="work_status" label="工作状态" width="100" sortable align="center"
                               :sort-orders="orders">
                <template slot-scope="scope">
                  <span v-if="scope.row.work_status === 1">实习</span>
                  <span v-else-if="scope.row.work_status === 2">兼职</span>
                  <span v-else-if="scope.row.work_status === 3">在职</span>
                  <span v-else-if="scope.row.work_status === 4">离职</span>
                </template>
              </el-table-column>
              <el-table-column prop="salary.month_total" label="合计" width="100" sortable :sort-orders="orders"
                               class-name="project_Free">
              </el-table-column>
              <el-table-column prop="salary.1" label="1月" width="100" sortable :sort-orders="orders"
                               class-name="project_three">
              </el-table-column>
              <el-table-column prop="salary.2" label="2月" width="100" sortable :sort-orders="orders"
                               class-name="project_three">
              </el-table-column>
              <el-table-column prop="salary.3" label="3月" width="100" sortable :sort-orders="orders"
                               class-name="project_three">
              </el-table-column>
              <el-table-column prop="salary.4" label="4月" width="100" sortable :sort-orders="orders"
                               class-name="project_three">
              </el-table-column>
              <el-table-column prop="salary.5" label="5月" width="100" sortable :sort-orders="orders"
                               class-name="project_three">
              </el-table-column>
              <el-table-column prop="salary.6" label="6月" width="100" sortable :sort-orders="orders"
                               class-name="project_three">
              </el-table-column>
              <el-table-column prop="salary.7" label="7月" width="100" sortable :sort-orders="orders"
                               class-name="project_three">
              </el-table-column>
              <el-table-column prop="salary.8" label="8月" width="100" sortable :sort-orders="orders"
                               class-name="project_three">
              </el-table-column>
              <el-table-column prop="salary.9" label="9月" width="100" sortable :sort-orders="orders"
                               class-name="project_three">
              </el-table-column>
              <el-table-column prop="salary.10" label="10月" width="100" sortable :sort-orders="orders"
                               class-name="project_three">
              </el-table-column>
              <el-table-column prop="salary.11" label="11月" width="100" sortable :sort-orders="orders"
                               class-name="project_three">
              </el-table-column>
              <el-table-column prop="salary.12" label="12月" width="100" sortable :sort-orders="orders"
                               class-name="project_three">
              </el-table-column>
              <el-table-column prop="salary.2026" label="2026年" width="100" sortable :sort-orders="orders"
                               class-name="project_Free">
              </el-table-column>
              <el-table-column prop="salary.2025" label="2025年" width="100" sortable :sort-orders="orders"
                               class-name="project_Free">
              </el-table-column>
              <el-table-column prop="salary.2024" label="2024年" width="100" sortable :sort-orders="orders"
                               class-name="project_Free">
              </el-table-column>
              <el-table-column prop="salary.2023" label="2023年" width="100" sortable :sort-orders="orders"
                               class-name="project_Free">
              </el-table-column>
              <el-table-column prop="salary.2022" label="2022年" width="100" sortable :sort-orders="orders"
                               class-name="project_Free">
              </el-table-column>
              <el-table-column prop="salary.2021" label="2021年" width="100" sortable :sort-orders="orders"
                               class-name="project_Free">
              </el-table-column>
              <el-table-column prop="salary.2020" label="2020年" width="100" sortable :sort-orders="orders"
                               class-name="project_Free">
              </el-table-column>
              <el-table-column prop="salary.2019" label="2019年" width="100" sortable :sort-orders="orders"
                               class-name="project_Free">
              </el-table-column>
              <el-table-column prop="salary.2018" label="2018年" width="100" sortable :sort-orders="orders"
                               class-name="project_Free">
              </el-table-column>
              <el-table-column prop="salary.2017" label="2017年" sortable :sort-orders="orders"
                               class-name="project_Free">
              </el-table-column>
            </template>

          </el-table>
        </div>
      </div>
    </el-main>

    <el-dialog lock-scroll :visible.sync="dialogVisible" :show-close="false" custom-class="maxss" width="1090px"
               :top="dialogTop" style="overflow: hidden;border-radius: 5px;">
      <div class="whole" ref="whole">
        <div style="width: 360px;margin-left: 10px; position: fixed;">
          <div class="cloneEvt">
            <span @click="seekEvt" style="cursor: pointer;">保存</span>
            <span @click="DelEvt" style="cursor: pointer;">刪除</span>
          </div>
          <div style="width: 392px;margin-top: 10px; ">
            <div style="height: 170px; border: 1px solid #D9D9D9; border-radius: 5px;background: #fff;">
              <div class="fromE">
                <div style="margin-top: 20px;">
                  <span style="margin-left: 10px;font-size: 12px;margin-right: 12px;">姓 名</span>
                  <el-input v-model="names" placeholder="请选择" style="width: 146px;height:30px ;"
                            :disabled="disableInput()"
                  ></el-input>
                  <el-radio-group v-model="radio" class="raids" :disabled="disableInput()">
                    <el-radio :label="1">男</el-radio>
                    <el-radio :label="2">女</el-radio>
                  </el-radio-group>
                </div>
                <div style="height: 30px;display: flex;margin-top: 20px;" v-if="userRole != 8">
                  <span style="margin-left: 10px;font-size: 12px;margin-top: 7px;margin-right: 8px;">身份证号码</span>
                  <el-input style="width: 270px;height: 30px !important; " v-model="identitycards"
                            placeholder="请填写"></el-input>
                </div>
                <div style="height: 30px;display: flex;margin-top: 20px;" v-if="userRole != 8">
                  <span style="margin-left: 10px;font-size: 12px;margin-top: 7px;margin-right: 8px;">身份证地址</span>
                  <el-input style="width: 270px;height: 30px !important; " v-model="identity_address"
                            placeholder="请填写"></el-input>
                </div>
              </div>
            </div>

            <div class="Completion_status">
              <div style="height: 30px;display: flex;">
                <span
                    style="font-size: 12px;width: 52px;margin-top: 5px;margin-left:10px;">籍&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;贯</span>
                <el-input style="width: 105px;height: 30px;" v-model="native_places" placeholder="请填写"
                          :disabled="disableInput()"></el-input>
              </div>
              <div style="height: 30px;">
                <span style="font-size: 12px;">生&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日</span>
                <el-input style="width: 105px;height: 30px;margin-right: 10px;" v-model="birthday"
                          :disabled="disableInput()"
                          placeholder="请填写"></el-input>
              </div>
              <div style="height: 30px;">
                <span style="font-size: 12px;margin-left:10px;">手机号码</span>
                <el-input style="width: 105px;height: 30px;" v-model="phones" placeholder="请填写"
                          :disabled="disableInput()"></el-input>
              </div>
              <div style="height: 30px;">
                <span style="font-size: 12px;">紧急联系人</span>
                <el-input style="width: 105px;height: 30px;margin-right: 10px;" v-model="emergency_contact"
                          :disabled="disableInput()"
                          placeholder="请填写"></el-input>
              </div>
              <div style="height: 30px;width: 100%;display: flex;justify-content:space-evenly;">
                <span style="font-size: 12px;margin-top: 8px;">紧急联系人手机号码</span>
                <el-input style="width: 220px;height: 30px !important; " v-model="emergency_contact_phone"
                          :disabled="disableInput()"
                          placeholder="请填写"></el-input>
              </div>
            </div>
            <!-- 内容区域 -->
            <div class="content">
              <div style="display: flex;flex-wrap: wrap;justify-content: space-between;">
                <div style="height: 30px;display: flex;margin-top: 20px;">
                  <span>所属公司</span>
                  <el-select :disabled="disableInput()" v-model="company_id" filterable placeholder="请选择"
                             @change="company_idChange" clearable>
                    <el-option v-for="(item, index) in company_one" :key="index" :label="item" :value="index"
                               v-if="index !== 0">
                    </el-option>
                  </el-select>
                </div>
                <div style="height: 30px;display: flex;margin-top: 20px;">
                  <span>所属部门</span>
                  <el-select :disabled="disableInput()" v-model="department_id" filterable placeholder="请选择"
                             @change="departmentChange"
                             clearable
                             style="margin-right: 10px;">
                    <el-option v-for="(item, index) in department_one" :key="index" :label="item.value_1"
                               :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <div style="height: 30px;display: flex;margin-top: 20px;">
                  <span>结算部门</span>
                  <el-select :disabled="disableInput()" v-model="settlement_id" filterable placeholder="结算部门"
                             @change="settlement_idChange"
                             clearable>
                    <el-option v-for="(item, index) in settlement_one" :key="index" :label="item.value_1"
                               :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <div style="height: 30px;display: flex;margin-top: 20px;">
                  <span>所属工种</span>
                  <el-select :disabled="disableInput()" v-model="production_id" filterable placeholder="所属工种"
                             @change="productionChange"
                             clearable
                             style="margin-right: 10px;">
                    <el-option v-for="(item, index) in production_one" :key="index" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <div style="height: 30px;display: flex;margin-top: 10px;">
                  <div style="display: flex;height: 20px;margin-top: 5px;">
                    <span style="width: 68px;">个人职业</span>
                    <el-checkbox-group :disabled="disableInput()" v-model="checkList"
                                       style="width: 365px;display: flex;margin-top: 5px;">
                      <el-checkbox label="助理" style="width:30px;height: 20px;"></el-checkbox>
                      <el-checkbox label="渲染" style="width:30px;height: 20px;margin-left: 12px;"></el-checkbox>
                      <el-checkbox label="模型" style="width:30px;height: 20px;margin-left: 12px;"></el-checkbox>
                      <el-checkbox label="市场" style="width:30px;height: 20px;margin-left: 20px;"></el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
                <div style="height: 30px;display: flex;margin-top: 20px;">
                  <span>工作状态</span>
                  <el-select :disabled="disableInput()" v-model="work_status" filterable placeholder="工作状态"
                             @change="work_status_boxChange"
                             clearable>
                    <el-option v-for="(item, index) in work_status_box_one" :key="index" :label="item" :value="index"
                               v-if="index !== 0">
                    </el-option>
                  </el-select>
                </div>
                <div style="height: 30px;display: flex;margin-top: 20px;">
                  <span>社保状态</span>
                  <el-select :disabled="disableInput()" v-model="social_securitys" filterable placeholder="社保状态"
                             @change="social_securityChange"
                             style="margin-right: 10px;font-size: 12px;" clearable>
                    <el-option v-for="(item, index) in socialsecurity_one" :key="index" :label="item" :value="index"
                               v-if="index !== 0">
                    </el-option>
                  </el-select>
                </div>
                <div style="height: 30px;display: flex;margin-top: 20px;">
                  <span>入职时间</span>
                  <el-date-picker :disabled="disableInput()" v-model="entry_time" type="date" placeholder="选择日期"
                                  style="width:128px">
                  </el-date-picker>
                </div>
                <div style="height: 30px;display: flex;margin-top: 20px;">
                  <span>离职时间</span>
                  <el-date-picker :disabled="disableInput()" v-model="departure_time" type="date" placeholder="选择日期"
                                  style="margin-right: 10px;width:128px">
                  </el-date-picker>
                </div>
                <div style="height: 30px;display: flex;margin-top: 20px;">
                  <span>合同到期</span>
                  <el-date-picker :disabled="disableInput()" v-model="contract_time" type="date" placeholder="选择日期"
                                  style="width:128px">
                  </el-date-picker>
                </div>
              </div>
            </div>
            <div class="fingerprint" v-if="userRole != 8">
              <div style="height: 30px;display: flex;margin-top: 10px;">
                <span style="margin-left: 7px;">备注</span>
                <textarea placeholder="请输入(备注)" v-model="remarks" id=""
                          style="width:285px;height: 180px;border: 1px solid #d1d1d1; margin-left: 7px;border-radius: 5px;"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 690px;margin-left:410px" v-if="userRole != 8">

          <div class="arrangement" ref="arrangement" id="tab1Content">
            <div>
              <el-upload class="upload-demo" drag action multiple disabled>
                <span>身份证正面</span>
              </el-upload>
            </div>
            <div>
              <el-upload class="upload-demo" drag action multiple disabled>
                <span>身份证背面</span>
              </el-upload>
            </div>
          </div>

          <div class="Mapping_quantity" ref="Mapping_quantity" id="tab3Content">
            <div class="box_header">
              <div class="box">
                <span>1</span>
                <div>
                  <span>总成本</span>
                  <span>120%</span>
                </div>
              </div>
              <div class="box">
                <span>1</span>
                <div>
                  <span>总成本</span>
                  <span>120%</span>
                </div>
              </div>
              <div class="box">
                <span>1</span>
                <div>
                  <span>总成本</span>
                  <span>120%</span>
                </div>
              </div>
              <div class="box">
                <span>1</span>
                <div>
                  <span>总成本</span>
                  <span>120%</span>
                </div>
              </div>
              <div class="box">
                <span>1</span>
                <div>
                  <span>总成本</span>
                  <span>120%</span>
                </div>
              </div>
            </div>

            <div class="fromEvt">
              <el-table :data="tableData" stripe style="width: 100%" height="523px">
                <el-table-column prop="zip" label="日期" width="88">
                </el-table-column>
                <el-table-column prop="zip" label="1" width="48">
                </el-table-column>
                <el-table-column prop="zip" label="2" width="48">
                </el-table-column>
                <el-table-column prop="zip" label="3" width="48">
                </el-table-column>
                <el-table-column prop="zip" label="4" width="48">
                </el-table-column>
                <el-table-column prop="zip" label="5" width="48">
                </el-table-column>
                <el-table-column prop="zip" label="6" width="48">
                </el-table-column>
                <el-table-column prop="zip" label="7" width="48">
                </el-table-column>
                <el-table-column prop="zip" label="8" width="48">
                </el-table-column>
                <el-table-column prop="zip" label="9" width="48">
                </el-table-column>
                <el-table-column prop="zip" label="10" width="48">
                </el-table-column>
                <el-table-column prop="zip" label="11" width="48">
                </el-table-column>
                <el-table-column prop="zip" label="12" width="73">
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>


    <el-dialog :visible.sync="dialogVisible_one" width="1400" custom-class="sousuo">
      <div style="height:450px;">
        <div>
          <span
              style="width: 69px;border: 1px solid #589ff9;height: 26px;font-size: 12px;line-height: 26px;color: #589ff9;border-radius: 3px;cursor: pointer;display: flex;justify-content: center;margin: 0 40px 30px;"
              @click="cleanUpEvt">ALL</span>
        </div>
        <div style="height:300px;display:flex">
          <div>
            <div style="margin-top: 10px;margin-left: 30px;">
              <span>员工姓名</span>
              <el-input v-model="name" clearable @change="getList"
                        :class="{ 'vip': name && name.length != '0' }" style="width: 180px ;height: 40px;">
              </el-input>
            </div>
          </div>
          <div>
            <div style="margin-top: 10px;margin-left: 30px;">
              <span>性别筛选</span>
              <el-cascader @change="sex_box" v-model="sex" popper-class='custom_box'
                           :options="options1" filterable clearable :class="{ 'vip': sex && sex !== '性别筛选' }"
                           style="width: 180px !important;height: 40px;margin-left: 15px;">
              </el-cascader>
            </div>

            <div style="margin-top: 10px;margin-left: 30px;">
              <span>籍贯</span>
              <el-input v-if="userRole != 5" v-model="native_place" clearable
                        :class="{ 'vip': native_place && native_place.length != '0' }" @change="getList"
                        style="width: 180px ;height: 40px;margin-left: 40px;">
              </el-input>
            </div>
            <div style="margin-top: 10px;margin-left: 30px;">
              <span>身份证号码</span>
              <el-input v-if="userRole != 5"
                        :class="{ 'vip': identitycard && identitycard.length != '0' }" v-model="identitycard" clearable
                        @change="getList" style="width: 180px ;height: 40px;">
              </el-input>
            </div>
            <div style="margin-top: 10px;margin-left: 25px;">
              <span>手机号</span>
              <el-input v-model="phone" @change="getList"
                        :class="{ 'vip': phone && phone.length != '0' }"
                        style="width: 180px ;height: 40px;margin-left: 30px;">
              </el-input>
            </div>
          </div>
          <div>
            <div style="margin-top: 10px;margin-left: 30px;">
              <span>所属公司</span>
              <el-cascader @change="company_name_box" v-model="company_name" :options="options2"
                           filterable clearable :class="{ 'vip': company_name && company_name !== '所属公司' }"
                           style="width: 180px ;height: 40px;">
              </el-cascader>
            </div>
            <div style="margin-top: 10px;margin-left: 30px;">
              <span>所属部门</span>
              <el-select v-model="department_two" filterable @change="signChange"
                         style="margin-left: 6px;width: 180px ;height: 40px;" clearable
                         :class="{ 'vip': department_two && department_two !== '所属部门' }">
                <el-option v-for="(item, index) in department_one" :key="index" :label="item.value_1"
                           :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div style="margin-top: 10px;margin-left: 30px;">
              <span>结算部门</span>
              <el-select v-model="settlement_tow" filterable @change="settlementChange"
                         style="margin-left: 6px;width: 180px ;height: 40px;" clearable
                         :class="{ 'vip': settlement_tow && settlement_tow !== '结算部门' }">
                <el-option v-for="(item, index) in settlement_one" :key="index" :label="item.value_1"
                           :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div style="margin-top: 10px;margin-left: 30px;">
              <span>工作状态</span>
              <el-cascader @change="work_status_box" v-model="work_status" :options="options4"
                           filterable clearable :class="{ 'vip': work_status && work_status !== '工作状态' }"
                           style="width: 180px ;height: 40px;">
              </el-cascader>
            </div>
            <div style="margin-top: 10px;margin-left: 30px;">
              <span>社保状态</span>
              <el-cascader v-if="userRole != 5" @change="social_security_box" v-model="social_security"
                           :options="options5" filterable clearable
                           :class="{ 'vip': social_security && social_security !== '社保状态' }"
                           style="width: 180px ;height: 40px;">
              </el-cascader>
            </div>

          </div>
          <div>
            <div style="margin-top: 10px;margin-left: 35px;">
              <span>入职时间</span>
              <el-date-picker v-model="value0" style="width: 180px ;height: 40px;margin-left: 6px;" type="daterange"
                              :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator=""
                              start-placeholder="" align="right" :class="{ 'your-css-class_box': !isValue3Empty_1 }"
                              value-format="timestamp" @change="getList">
              </el-date-picker>
            </div>
            <div style="margin-top: 10px;margin-left: 35px;">
              <span>离职时间</span>
              <el-date-picker v-model="value1" style="width: 180px ;height: 40px;margin-left: 6px;" type="daterange"
                              :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator=""
                              start-placeholder="" align="right" :class="{ 'your-css-class_box': !isValue3Empty_2 }"
                              value-format="timestamp" @change="getList">
              </el-date-picker>
            </div>
            <div style="margin-top: 10px;margin-left: 35px;">
              <span>合同到期</span>
              <el-date-picker v-if="userRole != 5" v-model="value2"
                              style="width: 180px ;height: 40px;margin-left: 6px;" type="daterange"
                              :picker-options="pickerOptions"
                              size="mini" format="yyyy-MM-dd" range-separator="" start-placeholder="" align="right"
                              :class="{ 'your-css-class_box': !isValue3Empty_3 }" value-format="timestamp"
                              @change="getList">
              </el-date-picker>
            </div>

          </div>
          <div>
            <div style="margin-top: 10px;margin-left: 30px;">
              <span>备注</span>
              <el-input v-if="userRole != 5" :class="{ 'vip': remark && remark.length != '0' }"
                        v-model="remark" clearable @change="getList" style="width: 180px ;height: 40px;">
              </el-input>
            </div>
          </div>
          <div></div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import List from "@/components/list.vue";
import pop_up from "@/components/pop_up.vue";
import GlobalHeader from '@/components/GlobalHeader.vue';
import {ERPStaffApi, ERPSearchApi, InfoThreeApi, EditThreeApi, StaffDelApi} from "@/api/staff/staff.js";
// import locationData from '@/assets/area/location_chs.js';
const delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
export default {
  components: {
    List,
    pop_up,
    GlobalHeader
  },
  data() {
    return {
      activeIndex: "3",
      active: 0,
      tableData: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const current = new Date();
              let nowDayOfWeek = current.getDay();
              if (nowDayOfWeek === 0) nowDayOfWeek = 7;
              const dayNum = 1 * 24 * 60 * 60 * 1000;
              const firstDate = new Date(current.valueOf() - (nowDayOfWeek - 1) * dayNum);
              const lastDate = new Date(new Date(firstDate).valueOf() + 6 * dayNum);
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "当月",
            onClick(picker) {
              const date = new Date();
              const year = date.getFullYear();
              const month = date.getMonth();
              let thisMonthStartDate = new Date(year, month, 1);
              let thisMonthEndDate = new Date(year, month + 1, 0);
              picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
            },
          },
          {
            text: "当年",
            onClick(picker) {
              var tYear = new Date().getFullYear();
              var startTime = new Date(tYear, 0, 1); //当前年第一天
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, start]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              const current = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000);
              let nowDayOfWeek = current.getDay();
              let diffToMonday =
                  current.getDate() - nowDayOfWeek + (nowDayOfWeek === 0 ? -6 : 1);
              const firstDate = new Date(current.setDate(diffToMonday));
              const lastDate = new Date(current.setDate(diffToMonday + 6));
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              var now = new Date();
              var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
              var ed = new Date(now.getFullYear(), now.getMonth(), 0);
              picker.$emit("pick", [fd, ed]);
            },
          },
          {
            text: "去年",
            onClick(picker) {
              var tYear = new Date().getFullYear() - 1;
              var startTime = new Date(tYear, 0, 1);
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
        ],
      },
      columnShow: {  // 列状态：显示（true） / 隐藏（false）
        nameColShow: true,  // 姓名列
        provinceColShow: true,  // 省份列
      },
      options1: [{
        value: '1',
        label: '男',
      }, {
        value: '2',
        label: '女',
      }],
      options2: [{
        value: '1',
        label: '成都',
      }, {
        value: '2',
        label: '上海',
      }],

      options4: [{
        value: '1',
        label: '实习',
      }, {
        value: '2',
        label: '兼职',
      }, {
        value: '3',
        label: '在职',
      }, {
        value: '4',
        label: '离职',
      }],

      options5: [{
        value: '1',
        label: '未缴纳',
      }, {
        value: '2',
        label: '缴纳',
      },],
      isValue3Empty_1: true,
      isValue3Empty_2: true,
      isValue3Empty_3: true,
      isValue3Empty_4: true,
      value0: '',
      value1: '',
      value2: '',
      source: null,
      status: null,
      //排序
      order: null,
      orField: null,
      name: null,
      sex: null,
      company_name: null,  //所属公司
      department: null, //所属部门
      phone: null,   //手机号码
      work_status: '3',  //工作状态
      social_security: null,  //社保状态
      native_place: null,    //籍贯
      identitycard: null, //身份证号码
      remark: null,  //备注
      remarks: null,  //备注
      total: null,
      paginationInput: 95,
      currentPage1: 1,
      department_one: null,
      settlement: null,
      department_two: null,
      settlement_one: null,
      settlement_tow: null,
      totalRow: null,
      showNameColumn: true,
      showNameColumn_box: false,
      showNameColumn_box_one: false,
      activeTab: '1',
      dialogVisible: false,

      sizeForm: null,
      Dataset: [],
      production_id: null,
      ability: [],
      contract_time: null,
      departure_time: null,
      entry_time: null,
      emergency_contact_phone: null,
      emergency_contact: null,
      identity_address: null,
      birthday: null,
      company_id: null,
      department_id: null,
      settlement_id: null,
      production_one: null,
      company_one: null,
      socialsecurity_one: null,
      work_status_box_one: null,
      checkList: [],

      names: null,
      phones: null,
      social_securitys: null,
      native_places: null,
      identitycards: null,
      radio: 1,
      orders: ['descending', 'ascending', null],
      dialogTop: null,
      userRole: localStorage.getItem("role"),  //权限

      loading: false, //
      dialogVisible_one: false,
    };
  },
  created() {
    this.loading = true
    ERPStaffApi({
      work_status: 3,
    }).then((res => {
      this.tableData = res.data,
          this.total = res.total,
          this.currentPage1 = res.page - 0;
      this.totalRow = res.totalRow;
      this.loading = false;
    }))
    ERPSearchApi({}).then((res => {
      this.department_one = res.data.department   //所属部门
      this.settlement_one = res.data.settlement   //结算部门
      this.production_one = res.data.production
      this.company_one = res.data.company
      this.socialsecurity_one = res.data.socialsecurity
      this.work_status_box_one = res.data.workstatus
    }))
    this.userRole = localStorage.getItem('role');
  },
  mounted() {
    // window.addEventListener("scroll", (e) => this.imgScrollEvt(e), true);
    window.addEventListener('scroll', this.saveScrollPosition);

    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.saveScrollPosition);
    // 在组件销毁前移除窗口尺寸变化的监听
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    placeholderText() {
      if (this.work_status !== null && this.work_status !== undefined) {
        // 查找对应的 label
        const selectedOption = this.options4.find(option => option.value === this.work_status);
        if (selectedOption) {
          return selectedOption.label; // 直接返回 label
        } else {
          return `${this.work_status}`;
        }
      } else {
        // 返回默认的 placeholder 文本
        return "请选择工作状态";
      }
    },
    hasContent() {
      const fields = [
        this.name,
        this.sex,
        this.company_name,
        this.department_two,
        this.settlement_tow,
        this.phone,
        this.social_security,
        this.value0,
        this.value1,
        this.value2,
        this.native_place,
        this.identitycard,
        this.remark,
      ];
      // 检查所有字段的长度是否为0
      return fields.some(field => (field && (Array.isArray(field) ? field.length > 0 : field !== '')));
    }
  },
  methods: {

    disableInput() {
      let role = localStorage.getItem("role")
      return role != "6"
    },
    DelEvt() {
      if (this.userRole == 8) {
        return;
      }
      this.$confirm('是否永久删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        StaffDelApi({
          id: this.selectedId,
        }).then(res => {
          if (res.code == 1000) {
            this.$message({
              type: 'success',
              message: '删除成功'
            });
            this.dialogVisible = false
            this.getList()
          } else {
            alert(res.msg)
          }
        })
      })
    },
    handleResize() {
      // 根据不同的屏幕尺寸设置不同的top值
      if (window.innerWidth <= 1920) {
        this.dialogTop = '1vh'
      } else if (window.innerWidth <= 2560) {
        this.dialogTop = '10vh'
      } else if (window.innerWidth <= 3440) {
        this.dialogTop = '15vh'
      } else if (window.innerWidth <= 3840) {
        this.dialogTop = '20vh'
      }
    },

    seekEvt() {
      if (this.userRole == 8) {
        return;
      }
      const params = {
        name: this.names,
        identitycard: this.identitycards, //身份证
        identity_address: this.identity_address, //身份证地址
        native_place: this.native_places,//籍贯
        birthday: this.birthday, //生日
        phone: this.phones,//手机号
        emergency_contact: this.emergency_contact, //紧急联系人
        emergency_contact_phone: this.emergency_contact_phone,//紧急联系人手机号
        company_id: this.company_id, //所属公司
        department_id: this.department_id,    //所属部门
        settlement_id: this.settlement_id,   //结算部门
        production_id: this.production_id, //所属工种
        ability: this.checkList, //个人能力
        work_status: this.work_status,  //工作状态
        social_security: this.social_securitys,  //社保状态
        entry_time: this.entry_time, //入职时间
        departure_time: this.departure_time, //离职时间
        contract_time: this.contract_time, //合同到期
        remark: this.remarks,
        sex: this.radio,
      }
      if (this.selectedId) {
        params.id = this.selectedId;
      }
      EditThreeApi(params).then(res => {
        if (res.code == 1000) {
          this.dialogVisible = false;
        } else {
          this.$message.success(res.msg);
        }
      })
    },
    //点击打开弹窗事件
    openChildDialog(type) {
      if (type == 1) {
        this.selectedId = '',
            this.names = '',
            this.identitycards = '',
            this.identity_address = '',
            this.native_places = '',
            this.birthday = '',
            this.phones = '',
            this.emergency_contact = '',
            this.emergency_contact_phone = '',
            this.company_id = '',
            this.department_id = '',
            this.settlement_id = '',
            this.production_id = '',
            this.ability = '',
            this.work_status = '',
            this.social_securitys = '',
            this.entry_time = '',
            this.departure_time = '',
            this.contract_time = '',
            this.remarks = '',
            this.checkList = [],
            this.radio = 1,
            this.dialogVisible = true
      } else if (type == 2) {
        //打开收入管理弹窗详情页
        InfoThreeApi({
          id: this.selectedId
        }).then((res) => {
          if (res.code == 1000) {
            this.names = res.data.data.name  //姓名
            this.identitycards = res.data.data.identitycard  //身份证
            this.identity_address = res.data.data.identity_address  //身份证地址
            this.native_places = res.data.data.native_place //籍贯
            this.birthday = res.data.data.birthday  //生日
            this.phones = res.data.data.phone  //手机号
            this.emergency_contact = res.data.data.emergency_contact  //紧急联系人
            this.emergency_contact_phone = res.data.data.emergency_contact_phone //紧急联系人手机号
            this.company_id = res.data.data.company_id  //所属公司

            this.department_id = res.data.data.department_id         //所属部门
            this.settlement_id = res.data.data.settlement_id   //结算部门
            this.production_id = res.data.data.production_id  //所属工种
            this.work_status = res.data.data.work_status  //工作状态
            this.social_securitys = res.data.data.social_security  //社保状态
            this.entry_time = res.data.data.entry_time //入职时间
            this.departure_time = res.data.data.departure_time  //离职时间
            this.contract_time = res.data.data.contract_time  //合同到期
            this.remarks = res.data.data.remark
            this.radio = res.data.data.sex
            this.checkList = res.data.data.ability || []  //个人能力

            this.production_one = res.data.production
            this.company_one = res.data.company
            this.socialsecurity_one = res.data.socialsecurity
            this.work_status_box_one = res.data.workstatus

            this.dialogVisible = true
          } else {
            alert(res.msg)
          }
        });
      }
    },


    ideograph(code) {
      const areas = [];
      if (Array.isArray(code) && code.length) {
        let region = this.options;
        for (let i = 0; i < code.length; i++) {
          const item = code[i];
          const found = region.find((regionItem) => regionItem.value === item);
          if (found) {
            areas.push(found.label); // 直接将中文推入数组中
            region = found.children || [];
            if (i === code.length - 1) {
              // 最后一个区域，可以打印或进行其他处理
            }
          } else {
            break;
          }
        }
      }
      return areas.join("/");
    },


    minxEvt() {
      this.showNameColumn_box = false
      this.showNameColumn_box_one = false
      this.showNameColumn_box_two = false
      this.showNameColumn_box_three = false
      this.$nextTick(() => {
        // 在这里执行需要在异步操作完成后执行的代码
        this.activeTab = '1';
        this.showNameColumn = true
      })
    },
    min_boxEvt() {
      setTimeout(res => {
        this.showNameColumn = false
        this.showNameColumn_box_one = false
        this.showNameColumn_box_two = false
        this.showNameColumn_box_three = false
        this.$nextTick(() => {
          this.activeTab = '2';
          // 在这里执行需要在异步操作完成后执行的代码
          this.showNameColumn_box = true
        })
      },)
    },
    min_oneEvt() {
      setTimeout(res => {
        this.showNameColumn_box = false
        this.showNameColumn = false
        this.showNameColumn_box_two = false
        this.showNameColumn_box_three = false
        this.$nextTick(() => {
          this.activeTab = '3';
          // 在这里执行需要在异步操作完成后执行的代码
          this.showNameColumn_box_one = true
        })
      },)

    },

    toggleColumn(column) {
      this.columnShow[column] = !this.columnShow[column];
    },

    huaguo(row, column, cell, event) {
      this.selectedId = row.id
    },
    idEvt(row, column, cell, event) {
      this.selectedId = row.id
    },

    handleOpen(key, keyPath) {
    },
    handleClose(key, keyPath) {
    },
    //分页
    handleCurrentChange(res) {
      this.loading = true
      setTimeout(() => {
        this.getList();
        this.loading = false
      }, 100)
    },
    getSummaries(param) {
      const {columns, tableData} = param;
      const sums = [];
      columns.forEach((column, index) => {
        for (let key in this.totalRow) {
          if (column.property == 'salary.' + key) {
            sums[index] = this.totalRow[key];
          } else if (column.property == key) {
            sums[index] = this.totalRow[key];
          } else if (column.property == key) {
            sums[index] = this.totalRow[key];
          }
        }
        if (index == 0) {
          sums[index] = "计数";
          return;
        }
      });
      return sums;
    },


    formatterEvt(refName, event) {
      const table = this.$refs[refName];
      const {column, prop, order} = event;

      // 清空上一次的排序记录
      // this.clearSort(refName);

      // 定义排序逻辑
      const sortData = () => {
        if (order === '') {
          this.tableData = [...this.tableData];
          return;
        }
        this.tableData.sort((a, b) => {
          if (order == 'ascending') {
            return a[prop] > b[prop] ? 1 : -1;
            this.loading = false;
          } else if (order == 'descending') {
            return a[prop] < b[prop] ? 1 : -1;
            this.loading = false;
          } else {
            return 0;
          }
        });

      };
      // 在这里根据需要进行其他操作，例如重新请求数据等
    },
    clearSort(refName) {
      const table = this.$refs[refName];
      // 清空排序状态
      table.clearSort();
    },


    //签单人选择下拉内容
    signChange(value_1) {
      this.department_two = value_1;
      this.getList()
    },
    settlementChange(value_1) {
      this.settlement_two = value_1;
      this.getList()
    },
    limitEvt() {
      this.getList();
    },
    //项目进度
    sex_box(selectedValues) {
      this.sex = selectedValues[0];
      this.getList();
    },
    //所属公司
    company_name_box(selectedValues) {
      this.company_name = selectedValues[0];
      this.getList();
    },
    //所属部门
    department_box(selectedValues) {
      this.department = selectedValues[0];
      this.getList();
    },
    //工作状态
    work_status_box(selectedValues) {
      this.work_status = selectedValues[0];
      this.getList();
    },
    //社保状态
    social_security_box(selectedValues) {
      this.social_security = selectedValues[0];
      this.getList();
    },

    //彈窗的所屬公司
    company_idChange(value) {
      this.company_id = value
    },
    //
    departmentChange(value) {
      this.department_id = value
    },
    settlement_idChange(value) {
      this.settlement_id = value
    },
    productionChange(value) {
      this.production_id = value
    },
    social_securityChange(value) {
      this.social_securitys = value
    },
    work_status_boxChange(value) {
      this.work_status_box = value
    },
    //   getSummariesEvt(param){
    //       const { columns, tableData } = param;
    //     const sums = [];
    //     columns.forEach((column, index) => {
    //       for (let key in this.totalRow) {
    //         if (column.property == 'salary.' + key) {
    //           sums[index] = this.totalRow[key];
    //         }
    //       }
    //     });
    //     return sums;
    // },


    //获取页面数据
    getList() {
      //入职时间
      let date4 = {
        start: this.value0[0],
        end: this.value0[1],
      };
      //入职时间
      var income_time_start = Math.floor(date4.start / 1000);
      var income_time_end = Math.floor(date4.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate4 = new Date(income_time_end * 1000);
      lastDate4.setHours(23, 59, 59);

      //离职时间
      income_time_end = Math.floor(lastDate4.getTime() / 1000);
      let date3 = {
        start: this.value1[0],
        end: this.value1[1],
      };
      var end_time_start = Math.floor(date3.start / 1000);
      var end_time_end = Math.floor(date3.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate3 = new Date(end_time_end * 1000);
      lastDate3.setHours(23, 59, 59);
      end_time_end = Math.floor(lastDate3.getTime() / 1000);


      //合同到期
      let date1 = {
        start: this.value2[0],
        end: this.value2[1],
      };
      var startTimestamp1 = Math.floor(date1.start / 1000);
      var endTimestamp1 = Math.floor(date1.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate1 = new Date(endTimestamp1 * 1000);
      lastDate1.setHours(23, 59, 59);
      endTimestamp1 = Math.floor(lastDate1.getTime() / 1000);
      this.loading = true
      let data = {
        orField: this.orField,
        orWhere: this.order,
        page: this.currentPage1,
        limit: this.paginationInput,
        name: this.name,
        sex: this.sex,
        company_name: this.company_name,
        department: this.department,
        phone: this.phone,
        work_status: this.work_status || 3,
        social_security: this.social_security,
        native_place: this.native_place,
        identitycard: this.identitycard,
        remark: this.remark,
        settlement: this.settlement_tow,
        department_two: this.department_two,


        departure_time_start: end_time_start ? end_time_start : '',
        departure_time_end: end_time_end ? end_time_end : '',


        entry_time_start: income_time_start ? income_time_start : '',
        entry_time_end: income_time_end ? income_time_end : '',

        contract_time_start: startTimestamp1 ? startTimestamp1 : '',
        contract_time_end: endTimestamp1 ? endTimestamp1 : '',
      };
      ERPStaffApi(data).then((res) => {
        this.tableData = res.data;
        this.total = res.total;
        this.totalRow = res.totalRow;

        // this.currentPage1 = res.page - 0;
        // this.dataLoaded = true; // 数据加载完成，修改dataLoaded的状态
        this.loading = false;
      });
    },
    //到处excel
    excelEvt() {
      //入职时间
      let date4 = {
        start: this.value0[0],
        end: this.value0[1],
      };
      //入职时间
      var income_time_start = Math.floor(date4.start / 1000);
      var income_time_end = Math.floor(date4.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate4 = new Date(income_time_end * 1000);
      lastDate4.setHours(23, 59, 59);

      //离职时间
      income_time_end = Math.floor(lastDate4.getTime() / 1000);
      let date3 = {
        start: this.value1[0],
        end: this.value1[1],
      };
      var end_time_start = Math.floor(date3.start / 1000);
      var end_time_end = Math.floor(date3.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate3 = new Date(end_time_end * 1000);
      lastDate3.setHours(23, 59, 59);
      end_time_end = Math.floor(lastDate3.getTime() / 1000);


      //合同到期
      let date1 = {
        start: this.value2[0],
        end: this.value2[1],
      };
      var startTimestamp1 = Math.floor(date1.start / 1000);
      var endTimestamp1 = Math.floor(date1.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate1 = new Date(endTimestamp1 * 1000);
      lastDate1.setHours(23, 59, 59);
      endTimestamp1 = Math.floor(lastDate1.getTime() / 1000);
      this.loading = true
      let data = {
        orField: this.orField,
        orWhere: this.order,
        page: this.currentPage1,
        limit: this.paginationInput,
        name: this.name,
        sex: this.sex,
        company_name: this.company_name,
        department: this.department,
        phone: this.phone,
        work_status: this.work_status || 3,
        social_security: this.social_security,
        native_place: this.native_place,
        identitycard: this.identitycard,
        remark: this.remark,
        settlement: this.settlement_tow,
        department_two: this.department_two,


        departure_time_start: end_time_start ? end_time_start : '',
        departure_time_end: end_time_end ? end_time_end : '',


        entry_time_start: income_time_start ? income_time_start : '',
        entry_time_end: income_time_end ? income_time_end : '',

        contract_time_start: startTimestamp1 ? startTimestamp1 : '',
        contract_time_end: endTimestamp1 ? endTimestamp1 : '',
        excel: 1,
        activeTab: this.activeTab,
      };
      let genExcel = false;
      if (genExcel == false) {
        ERPStaffApi(data).then((res) => {
          this.loading = false
          window.location.href = res
          genExcel = true
        });
      } else if (genExcel == true) {
        alert('正在生成数据请勿重复请求')
      }

    },
    //清除数据
    cleanUpEvt() {
      // 清空其他变量和重置表格数据
      this.name = '';
      this.value0 = '';
      this.value1 = '';
      this.value2 = '';
      this.value3 = '';
      this.sex = '';
      this.currentPage1 = 1;
      this.department = '';
      this.phone = '';
      this.social_security = '';
      this.native_place = '';
      this.identitycard = '';
      this.$refs.sortTable.clearSort();
      this.remark = '';
      this.input11 = '';
      this.company_name = '';
      this.work_status = '';
      this.department_id = '';
      this.settlement_tow = '';
      this.department_two = '';
      ERPStaffApi({}).then((res) => {
        this.tableData = res.data;
        this.currentPage1 = res.page - 0;
        this.total = res.total;
        this.totalRow = res.totalRow;
        this.loading = false
      });
    },

  },
  watch: {
    'value0': function (newVal, oldVal) {
      this.isValue3Empty_1 = !newVal;
    },
    'value1': function (newVal, oldVal) {
      this.isValue3Empty_2 = !newVal;
    },
    'value2': function (newVal, oldVal) {
      this.isValue3Empty_3 = !newVal;
    },
    'value3': function (newVal, oldVal) {
      this.isValue3Empty_4 = !newVal;
    },
    active() {
      // 切换 table 的时候恢复滚动位置
      this.$nextTick(() => {
        window.scrollTo(0, this.scrollPosition);
      });
    },
  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import url("../../style/multiplex.less");


/* 固定左侧的项目管理列表 */
.el-aside {
  position: fixed;
  top: 50px;
  /* 顶部Header的高度，根据你的实际Header高度调整 */
  left: 0;
  width: 155px;
  height: 100%;
  /* 使其充满整个可视区域的高度 */
  z-index: 99;
  /* 使其在正文内容之上 */
}

.el-main {
  left: 175px;
  /* 与左侧项目管理列表的宽度保持一致 */
  padding: 0px;
  /* 添加一些内边距，使内容不紧贴在边缘 */
  top: 60px;
  position: relative;
}

/deep/ .el-submenu__title {
  height: 39px !important;
  line-height: 39px !important;
  list-style: none;
}


.edit {
  // width: 1000px;
  height: 50px;
  display: flex;

  div {
    height: 26px;
    cursor: pointer;
  }

  .el-input {
    width: 137px;
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    width: 137px;
    margin-left: 5px;
  }

  span {
    width: 69px;
    height: 26px;
    font-size: 12px;
    line-height: 26px;
    color: #589ff9;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /deep/ .el-input__inner {
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    font-size: 12px;
    padding-left: 10px;
  }

  /deep/ .el-input__icon {
    line-height: 0px;
  }
}

.span_box {
  position: absolute;
  left: 1px;
  top: 95px !important;
  height: 35px;
  width: 80px;
  background: #fff;
  z-index: 120;
  font-size: 14px;
  line-height: 35px;
  text-align: left;
  padding-left: 13px;
}

/deep/ .el-table th.el-table__cell {
  background: #dce6ee;
}

.pagination_box {
  min-width: 500px;
  display: flex;
  // align-items: center;
  justify-content: flex-end;
  position: absolute;
  right: 1px;
  z-index: 123;
  cursor: pointer;
}

/deep/ .el-tabs--border-card {
  border: none;
}

/deep/ .el-tabs--border-card > .el-tabs__content {
  padding: 0 !important;
}

/deep/ .el-table__body-wrapper {
  overflow-y: auto;
}

/deep/ .el-table__footer-wrapper {
  position: fixed;
  top: 145px;
  z-index: 111;
  height: 49px;
  background-color: #fff;
  width: calc(100% - 178px);
}

.mainx {
  margin-top: 50px;
}

/deep/ .el-table th.el-table__cell {
  background: #f5f7fa;
}

/deep/ .el-tabs__header {
  width: 100%;
}

/deep/ .el-table__footer-wrapper .gutter {
  background: #f5f7fa;
  border-top: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
  display: none !important;
}


/* 添加一个新的类来将总计行移动到最上方 */
.move-top .el-table__summary-cell {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  /* 根据需要调整背景颜色、字体样式等 */
}

/deep/ .el-table__fixed-footer-wrapper {
  display: none;
}

/deep/ .el-badge__content.is-fixed {
  display: none;
}

/deep/ .el-tabs__item {
  border-radius: 3px 3px 0px 0px;
  background: #d9d9d9;
  margin-left: 4px;
  color: #979797;
  font-size: 12px;
}

/deep/ .el-tabs__active-bar {
  display: none;
}

/deep/ .el-tabs__item {
  padding: 0;
  width: 105px;
  height: 32px;
  line-height: 32px;
}

/deep/ .el-tabs__item.is-active {
  background: #fff;
  border: 1px solid #d9d9d9;
  color: #000;
  border-bottom: none;
}

/deep/ .el-table__footer-wrapper tbody td.el-table__cell {
  background: #fff;
  border: none;
}

/deep/ .el-table__footer-wrapper .gutter {
  background: #fff !important;

}

/deep/ .gutter {
  display: none !important;
}

//修改tabs的下划线 以及颜色
/deep/ .el-tabs__nav-wrap::after {
  height: 0;
  border: 1px solid #d9d9d9;
}

/deep/ .el-tabs__nav {
  transform: translateY(1px) !important;
}

/deep/ .el-table th.el-table__cell > .cell {
  color: #333333;
  font-size: 12px;
  height: 23px;

}

/deep/ .el-table td.el-table__cell div {
  font-size: 12px;
}

/deep/ ::placeholder {
  color: #59565a;
  /* 这里替换为你想要的颜色值 */
  margin-left: 5px !important;
}

// /deep/.el-input--suffix {
//   width: 137px;
// }


.maxs {
  background: #f00 !important;
}

/deep/ .el-dialog__body {
  padding: 0 !important;
}

/deep/ .el-collapse-item {
  width: 490px !important;
}

.Completion_status /deep/ .el-input__inner {
  height: 30px !important;
}

.fromE /deep/ .el-input__inner {
  height: 30px !important;
}

/deep/ .vip .el-input__inner {
  background-color: #bcd9f8d4 !important;
}

//日期选择背景色改变
.your-css-class_box {
  background-color: #bcd9f8d4 !important;
}

//调整下拉选择input
.el-cascader {
  line-height: 25px;
  margin-left: 6px
}

// .el-cascader /deep/.el-input__inner {
//   height: 27px !important;
//   min-width: 137px !important;
// }


//溢出隐藏
.white_over {
  white-space: nowrap;
  overflow: hidden;
}


.btn2 {
  display: flex;
  align-items: center;
}

button {
  outline: none;
  border: 1px solid #d1d1d1;
  margin: 0 2px;
  /* 添加这一行 */
  width: 100px;
  height: 35px;
  cursor: pointer;
}

button.active {
  border-bottom: none;
  outline: none;
  background-color: #fff;
}


.whole {
  width: 1110px;
  height: 960px;
  display: flex;
  overflow-y: scroll !important;
  background-color: #D9D9D9;
  border-radius: 5px;
}

/* 设置滚动条宽度 */
.whole::-webkit-scrollbar {
  width: 8px;
  /* 调整滚动条宽度 */
}

/* 设置滚动条的轨道背景色 */
.whole::-webkit-scrollbar-track {
}

/* 设置滚动条手柄（拖动条）颜色 */
.whole::-webkit-scrollbar-thumb {
  background-color: #888;
}

//图量安排
.arrangement {
  width: 100%;
  height: 170px;
  margin-top: 45px;
  justify-content: space-evenly;
  align-items: center;
  border-radius: 5px;
  display: flex;

  div {
    width: 350px;
    height: 170px;
  }

  /deep/ .el-upload-dragger {
    width: 340px;
    line-height: 170px;
    color: #979797;
    background: #fff;
    border: none;
    height: 170px;
    z-index: 111;
  }
}

//成图全部图片
.Mapping_quantity {
  width: 100%;
  height: 700px;
  margin-top: 10px;
  display: inline-block;
  background: #fff;
  border-radius: 5px;

  .box {
    height: 70px;
    width: 120px;
    border: 1px solid;
    border-radius: 5px;
    background: #979797;

    span {
      text-align: left;
      display: block;
      margin-left: 6px;
    }

    div {
      margin-top: 29px;
      display: flex;
      justify-content: space-between;
      margin-right: 13px;
      font-size: 12px;
    }
  }

  /deep/ .el-input--suffix {
    width: 150px;
  }
}

.content /deep/ .el-input--suffix {
  width: 127px;
  height: 30px;
}

.content /deep/ .el-input__inner {
  height: 30px !important;
  font-size: 12px;
}

.content /deep/ .el-input__icon {
  line-height: 30px !important;
}

.box_header {
  display: flex;
  justify-content: space-between;
  width: 100%;
  border: 1px solid;
  margin: 20px auto 0 auto;
  color: #fff;
}


.Completion_status {
  height: 170px;
  margin-top: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background: #fff;
  border-radius: 5px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  // div {
  //   width: 150px;
  //   height: 50px;
  //   margin-left: 10px;
  //   margin-right: 10px;
  //   display: flex;
  //   flex-direction: column;
  //   margin-top: 5px;
  // }

  // span {
  //   text-align: left;
  //   font-size: 12px;
  // }

  // input {
  //   margin-top: 6px;
  //   display: inline-flex;
  //   align-items: center;
  //   border-radius: 5px;
  //   border: 0.5px solid #D9D9D9;
  //   height: 30px;
  //   outline: none;
  //   text-indent: 1em;
  // }
}

//内容区域
.content {
  height: 308px;
  margin-top: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  background: #fff;

  span {
    padding: 0 7px;
    font-size: 12px;
    margin-top: 7px;
  }

  .content_header {
    width: 98%;
    height: 152px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;

    input {
      margin-top: 6px;
      display: inline-flex;
      align-items: center;
      border-radius: 5px;
      border: 0.5px solid #D9D9D9;
      height: 30px;
      outline: none;
      text-indent: 1em;
    }
  }

  .content_center {
    width: 98%;
    height: 37px;
    line-height: 37px;
    display: flex;

    label {
      display: flex;

      input {
      }
    }

    .personal_ability {
      width: 60px;
      font-size: 12px;
    }
  }

}

.fingerprint {
  height: 203px;
  margin-top: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  background: #fff;
  font-size: 12px;

  textarea {
    border: none;
    outline: none;
    font-size: 12px;
  }
}

//表单
.fromEvt {
  width: 100%;
  height: 400px;
  margin: 55px auto 0 auto;
}

.fromEvt /deep/ .el-table__body-wrapper {
  height: 500px !important;
}

.fromEvt /deep/ .el-table {
  height: 550px !important;
}

// 删除和保存的样式
.cloneEvt {
  display: flex;
  height: 24px;
  margin-top: 10px;

  span:nth-child(1) {
    display: flex;
    width: 70px;
    padding: 5px 20px;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    background: #3383EA;
    font-size: 12px;
    color: #fff;
    margin-right: 10px;
  }

  span:nth-child(2) {
    display: flex;
    width: 70px;
    padding: 5px 20px;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    background: #979797;
    font-size: 12px;
    color: #fff;
  }
}

/deep/ .el-dialog__header {
  padding: 0 20px 0px !important;
}

.raids {
  label {
    margin-left: 15px;
    margin-right: 0px;
  }
}

/deep/ .el-checkbox__label {
  line-height: 16px !important;
  padding-left: 10px !important;
}

/deep/ .el-form-item--mini.el-form-item {
  margin-bottom: 15px !important;
}

/deep/ .el-form-item__label {
  font-size: 12px !important;
}

//项目管理列的颜色
/deep/ .project_one {
  background: #e1feea !important;
}

/deep/ .project_two {
  background: #d4d0f5 !important;
}


/deep/ .el-table__footer tbody tr .project_one {
  background: #fff !important;
}

/deep/ .el-table__footer tbody tr .project_two {
  background: #fff !important;
}


/deep/ .project_three {
  background: rgb(224, 255, 243) !important;
}

/deep/ .project_Free {
  background: rgb(215, 232, 243) !important;
}

/deep/ .project_showNameColumn {
  background: rgb(223, 242, 243) !important;
}


/deep/ .el-table__footer tbody tr .project_three {
  background: #fff !important;
}

/deep/ .el-table__footer tbody tr .project_Free {
  background: #fff !important;
}

/deep/ .el-table__footer tbody tr .project_showNameColumn {
  background: #fff !important;
}


/deep/ .sousuo {
  margin: 90px 0 0 325px !important;
  width: 1500px;
}

/deep/ .sousuo .el-dialog__header {
  padding: 20px 20px 10px !important;
}

/deep/ .sousuo .el-dialog__body {
  font-size: 13px !important;
}

/deep/ ::placeholder {
  color: #e5e5e5;
}
</style>
<style>
/* 日期选择背景色改变 */

.your-css-class_box .el-range-input {
  background-color: #8fc6ff00 !important;
}

/* 日期选择 第四个位置间距拉开 */
.el-picker-panel__sidebar button:nth-child(4) {
  margin-bottom: 30px;
}

.el-tooltip__popper.is-dark {
  background-color: #589ff9 !important;
}

.el-tooltip__popper .popper__arrow {
  display: none !important;
}
</style>





// WEBPACK FOOTER //
// src/src/Staff_management/index.vue